import React, { Component } from "react";
import { Button, Table, Row, Col, PageHeader, Input, Icon, Pagination } from "antd";
import Highlighter from "react-highlight-words";
import { connect } from "react-redux";
import QaStandartsForm from "./form";
import DetailsImportExport from "./details";

import * as actionCreators from "./../../actions/qa.standart";
import { tableSort, tableFooter } from "./../../../../components/util";
import moment from "moment";
import { ClearFilterButton } from "../../../../components/ListButtons/clearFilter";

import "./standart.css";
const formatDate = "DD-MM-YYYY";

const defaultFilters = { mostra_lista_eliminados: 0, ordenacao_data: "DESC" };
export class QaStandarts extends Component {
    componentDidMount() {
        if (!this.props.isFetched) this.selectData({ pagina: 1, resultados_pagina: 10 });
    }

    state = {
        isFormVisible: false,
        isModalDetailsVisible: false,
        filterParameters: {
            ...defaultFilters,
        },
    };

    selectData = (obj) => {
        this.setState({
            isFetching: true,
        });
        this.props
            .selectQaStandart({
                ...this.state.filterParameters,
                ...obj,
            })
            .then(() => {
                this.setState({
                    isFetching: false,
                });
            });
    };

    /** for search results in table */
    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={(node) => {
                        this.searchInput = node;
                    }}
                    placeholder={`Pesquisar`}
                    value={selectedKeys}
                    onChange={(e) => setSelectedKeys(e.target.value ? e.target.value : null)}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Pesquisar
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    limpar
                </Button>
            </div>
        ),
        filterIcon: (filtered) => <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />,
        // onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        filteredValue: this.state.filterParameters[`filtro_${dataIndex}`] || null,
        render: (text) => {
            text = typeof text === "object" ? "" : text;
            return (
                <Highlighter
                    highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            );
        },
    });

    getColumnSortProps = (dataIndex) => {
        const orderInState = this.state.filterParameters[`ordenacao_${dataIndex}`];
        return {
            sortOrder: orderInState === "ASC" ? "ascend" : orderInState === "DESC" ? "descend" : null,
        };
    };

    handleSearch = (_, confirm) => {
        confirm();
    };

    handleReset = (clearFilters) => {
        clearFilters();
    };
    /****************************** */

    /** configs table */

    handlePageChange = (page, pageSize) => {
        this.selectData({ pagina: page, resultados_pagina: pageSize });
    };

    handleShowSizeChange = (current, pageSize) => {
        this.selectData({ pagina: current, resultados_pagina: pageSize });
    };

    handleTableChange = (_, filters, sorter) => {
        console.log("filters:", filters);
        const obj = {};
        if (filters) {
            console.log("tableChange:", filters);
            Object.entries(filters).forEach(([key, val]) => {
                if (Array.isArray(val)) {
                    if (val.length > 0) obj["filtro_" + key] = val[0];
                } else if (val) obj["filtro_" + key] = val;
            });
        }

        if (sorter.columnKey && sorter.order) {
            obj["ordenacao_" + sorter.columnKey] = sorter.order === "ascend" ? "ASC" : "DESC";
        }

        const objFilter = {
            pagina: 1,
            resultados_pagina: this.props.resultadosPagina,
            ...obj,
        };
        this.setState({ filterParameters: obj }, () => {
            this.selectData(objFilter);
        });
    };

    handleEdit = (record) => {
        this.setState({
            isModalDetailsVisible: true,
            idDetails: record.id_insere_normas,
            nome: record.nome_norma,
        });
    };

    handleDetailsCancel = () => {
        this.setState({
            isModalDetailsVisible: false,
        });
    };

    // sortedInfo = filter.sorter || {};

    /************************************ */
    showModalForm = () => {
        this.setState({
            isFormVisible: true,
        });
    };

    handleOk = (e) => {
        this.setState({
            isFormVisible: false,
        });
        this.selectData({ pagina: 1, resultados_pagina: 10 });
    };

    handleCancel = (e) => {
        this.setState({
            isFormVisible: false,
        });
    };

    clearFormFilters = () => {
        this.setState(
            {
                filterParameters: {
                    ...defaultFilters,
                },
            },
            () => {
                this.selectData(defaultFilters);
            }
        );
    };

    columns = [
        {
            title: "Data",
            dataIndex: "data",
            width: "30%",
            sortDirections: ["descend", "ascend"],
            defaultSortOrder: "descend",
            sorter: (a, b) => {
                const data1 = moment(a.data, formatDate);
                const data2 = moment(b.data, formatDate);
                if (!data1.isValid()) {
                    return -1;
                }
                if (data1.isAfter(data2, "day")) {
                    return 1;
                }

                if (data1.isSame(data2, "day")) {
                    return 0;
                }

                return -1;
            },
        },
        {
            title: "Ação realizada",
            dataIndex: "acao",
            width: "20%",
            filters: [
                { text: "Importar", value: "importar" },
                { text: "Exportar", value: "exportar" },
            ],
            filterMultiple: false,
            sorter: (a, b) => tableSort(a.acao, b.acao),
        },
        {
            title: "Norma",
            dataIndex: "nome_norma",
            width: "30%",
            sorter: (a, b) => tableSort(a.nome_norma, b.nome_norma),
        },
        {
            title: "Ação",
            dataIndex: "operation",
            width: "20%",
            render: (text, record) => (
                <Button type="link" onClick={() => this.handleEdit(record)}>
                    Consultar
                </Button>
            ),
        },
    ];

    render() {
        const showClearFilterButton = true;

        console.log("render:", this.state.filterParameters);

        const columnsWithFilters = this.columns.map((el) => {
            if (el.dataIndex === "data") {
                return {
                    ...el,
                    ...this.getColumnSearchProps("data"),
                    ...this.getColumnSortProps("data"),
                };
            } else if (el.dataIndex === "nome_norma") {
                return {
                    ...el,
                    ...this.getColumnSearchProps("nome_norma"),
                    ...this.getColumnSortProps("nome_norma"),
                };
            } else if (el.dataIndex === "acao") {
                return {
                    ...el,
                    ...this.getColumnSortProps("acao"),
                };
            }

            return el;
        });

        return (
            <>
                <PageHeader title="Normativos"></PageHeader>
                <br />
                <Row type="flex" justify="end">
                    <Col>
                        {showClearFilterButton && <ClearFilterButton onClick={this.clearFormFilters} />}

                        <Button
                            onClick={this.showModalForm}
                            type="primary"
                            icon="plus"
                            style={{ marginBottom: 16, marginLeft: "1rem", fontSize: "1rem" }}
                        >
                            Inserir
                        </Button>
                    </Col>
                </Row>

                {this.state.isModalDetailsVisible && (
                    <DetailsImportExport
                        isVisible={this.state.isModalDetailsVisible}
                        handleCancel={this.handleDetailsCancel}
                        id={this.state.idDetails}
                        nome={this.state.nome}
                    />
                )}
                <Table
                    rowKey={(record) => record.id_insere_normas}
                    columns={columnsWithFilters}
                    dataSource={this.props.list}
                    loading={this.state.isFetching}
                    pagination={false}
                    footer={() => tableFooter(this.props.total)}
                    onChange={this.handleTableChange}
                    size="middle"
                />
                {this.props.isFetched && (
                    <>
                        <Row>
                            <Col xs={24}>
                                <Pagination
                                    showTitle
                                    size="small"
                                    showSizeChanger
                                    showLessItems
                                    onShowSizeChange={this.handleShowSizeChange}
                                    onChange={this.handlePageChange}
                                    current={this.props.pagina}
                                    total={this.props.total}
                                    style={{ float: "right" }}
                                />
                            </Col>
                        </Row>
                    </>
                )}

                {this.state.isFormVisible && (
                    <QaStandartsForm
                        isVisible={this.state.isFormVisible}
                        handleCancel={this.handleCancel}
                        handleOk={this.handleOk}
                    />
                )}
            </>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        list: Object.values(state.qaStandarts.domain.byId),
        isFetched: state.qaStandarts.app.isFetched,
        total: Number(state.qaStandarts.domain.metadata.attributes.resultados),
        pagina: Number(state.qaStandarts.domain.metadata.attributes.pagina),
        resultadosPagina: state.qaStandarts.domain.metadata.attributes.resultados_pagina,
    };
};

const mapDispatchToProps = {
    selectQaStandart: actionCreators.selectQaStandart,
};

export default connect(mapStateToProps, mapDispatchToProps)(QaStandarts);
